import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { Font, Color, ColorEnvironment, Flexbox } from './Styles';
import Image from './Image';

const styles = StyleSheet.create({
  container: {
    width: 70,
    marginLeft: 10,
    marginRight: 10
  },
  circle: {
    height: 65,
    width: 65,
    boxSizing: 'border-box',
    borderRadius: '100%',
    border: `5px solid ${Color.primary}`
  },
  label: {
    textAlign: 'center'
  }
});

class HazardComponent extends Component {
  render() {
    return(
      <div className={css(styles.container, Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)} onClick={this.props.onClick}>
        <Image extraStyles={[styles.circle, ColorEnvironment.normal]} filename={this.props.hazard.iconFilename}/>
        <div className={css(styles.label, Font.label)}>{this.props.hazard.hazard}</div>
      </div>
    );
  }
}

export default HazardComponent;



// WEBPACK FOOTER //
// ./src/HazardComponent.js